'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoCard = function (_React$PureComponent) {
  _inherits(VideoCard, _React$PureComponent);

  function VideoCard() {
    _classCallCheck(this, VideoCard);

    return _possibleConstructorReturn(this, (VideoCard.__proto__ || Object.getPrototypeOf(VideoCard)).apply(this, arguments));
  }

  _createClass(VideoCard, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        {
          width: this.props.size,
          height: this.props.size,
          viewBox: '0 0 113 108',
          version: '1.1',
          xmlnsXlink: 'http://www.w3.org/1999/xlink'
        },
        _react2.default.createElement(
          'g',
          {
            transform: 'translate(-13.000000, -16.000000) translate(13.000000, 16.000000)',
            stroke: 'none',
            strokeWidth: 1,
            fill: 'none',
            fillRule: 'evenodd'
          },
          _react2.default.createElement('path', {
            d: 'M112.147 80.007c.085 13.018-8.93 24.251-21.454 26.734-12.524 2.483-25.005-4.49-29.703-16.594H7.824C3.502 90.147 0 86.183 0 81.287V19.635c0-4.881 3.502-8.846 7.824-8.846h81.632c4.375 0 7.81 3.965 7.81 8.846v35.91c9.126 4.593 14.898 14.08 14.881 24.463z',
            fill: '#000',
            fillRule: 'nonzero',
            opacity: '0.15'
          }),
          _react2.default.createElement('path', {
            d: 'M7.824 5.394C3.502 5.394 0 9.359 0 14.24v61.667c0 4.882 3.502 8.846 7.824 8.846h81.632c4.322 0 7.824-3.964 7.824-8.846V14.24c-.013-4.881-3.45-8.846-7.824-8.846H7.824z',
            fill: '#6C3E7F'
          }),
          _react2.default.createElement('path', {
            d: 'M7.824 0C3.502 0 0 3.965 0 8.846V70.5c0 4.881 3.502 8.846 7.824 8.846h81.632c4.322 0 7.824-3.965 7.824-8.846V8.846C97.267 3.965 93.83 0 89.456 0H7.824z',
            fill: '#9B59B6'
          }),
          _react2.default.createElement('path', {
            d: 'M48.091 55.666c-9.103.135-16.598-7.27-16.757-16.56.128-2.388 2.064-4.257 4.408-4.257 2.344 0 4.279 1.87 4.407 4.258 0 4.468 3.55 8.09 7.93 8.09 4.379 0 7.929-3.622 7.929-8.09.128-2.389 2.063-4.258 4.407-4.258s4.28 1.87 4.407 4.258c-.159 9.278-7.637 16.68-16.73 16.56m12.343-24.651a4.406 4.406 0 0 1-3.08-1.255 4.263 4.263 0 0 1-1.267-3.04c0-1.148.458-2.246 1.268-3.041a4.377 4.377 0 0 1 6.145 0 4.249 4.249 0 0 1 1.274 3.04c0 1.15-.46 2.248-1.274 3.041a4.406 4.406 0 0 1-3.08 1.255m-24.739 0a4.406 4.406 0 0 1-3.08-1.255 4.263 4.263 0 0 1-1.267-3.04c0-1.148.458-2.246 1.268-3.041a4.39 4.39 0 0 1 6.158 0 4.263 4.263 0 0 1 1.268 3.04 4.263 4.263 0 0 1-1.268 3.041 4.406 4.406 0 0 1-3.079 1.255',
            fill: '#FFF'
          }),
          _react2.default.createElement('path', {
            d: 'M9.25 69.07a1.437 1.437 0 0 0-1.065.406c-.287.277-.45.661-.454 1.064.003.404.167.79.453 1.07.286.279.671.428 1.067.414h79.624c.406.025.805-.118 1.107-.397a1.55 1.55 0 0 0 .492-1.087 1.497 1.497 0 0 0-.48-1.096 1.435 1.435 0 0 0-1.12-.374H9.252z',
            fill: '#703C7E'
          }),
          _react2.default.createElement('ellipse', {
            fill: '#1ABC9C',
            fillRule: 'nonzero',
            cx: '85.6501416',
            cy: '74.6531452',
            rx: '26.5765213',
            ry: '27.2667376'
          }),
          _react2.default.createElement('path', {
            d: 'M78.064 61.842v25.81c.003.298.09.589.251.837.191.338.516.575.891.65.375.074.764-.02 1.065-.26l17.841-12.918a1.43 1.43 0 0 0 .37-.39 1.544 1.544 0 0 0-.37-2.078l-17.84-12.81c-.231-.17-.51-.26-.794-.257a1.455 1.455 0 0 0-1.414 1.416z',
            fill: '#FFF'
          }),
          _react2.default.createElement('path', {
            d: 'M93.13 10.033c-.73 0-1.321-.604-1.321-1.349a2.568 2.568 0 0 0-.643-2.019 2.46 2.46 0 0 0-1.921-.812c-.73 0-1.322-.604-1.322-1.349s.592-1.349 1.322-1.349a5.037 5.037 0 0 1 3.798 1.593 5.254 5.254 0 0 1 1.409 3.936c0 .358-.14.701-.387.954a1.308 1.308 0 0 1-.935.395z',
            fill: '#FFF',
            fillRule: 'nonzero',
            opacity: '0.5'
          }),
          _react2.default.createElement('path', { d: 'M75.302 4.504h8.617', fill: '#231F20', fillRule: 'nonzero' }),
          _react2.default.createElement('path', {
            d: 'M83.919 5.853h-8.59c-.73 0-1.322-.604-1.322-1.349s.592-1.349 1.322-1.349h8.59c.73 0 1.321.604 1.321 1.349s-.591 1.349-1.321 1.349z',
            fill: '#FFF',
            fillRule: 'nonzero',
            opacity: '0.3'
          }),
          _react2.default.createElement('path', { d: 'M93.13 24.3V14.16', fill: '#231F20', fillRule: 'nonzero' }),
          _react2.default.createElement('path', {
            d: 'M93.13 25.622c-.73 0-1.321-.604-1.321-1.349V14.16c0-.744.591-1.348 1.321-1.348s1.322.604 1.322 1.348v10.114c0 .745-.592 1.349-1.322 1.349z',
            fill: '#FFF',
            fillRule: 'nonzero',
            opacity: '0.3'
          }),
          _react2.default.createElement('path', {
            d: 'M9.41 68.005a2.482 2.482 0 0 0-1.857.696 2.587 2.587 0 0 0-.787 1.853c.01.698.297 1.363.795 1.843.497.48 1.164.735 1.848.705h19.176c1.446.062 2.67-1.074 2.75-2.548-.001-.722-.3-1.41-.823-1.895a2.48 2.48 0 0 0-1.927-.654H9.41z',
            fill: '#50D8BE'
          })
        )
      );
    }
  }]);

  return VideoCard;
}(_react2.default.PureComponent);

VideoCard.defaultProps = {
  size: '24'
};

VideoCard.propTypes = {
  size: _propTypes2.default.number
};

exports.default = VideoCard;